import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import AuthCallback from './components/AuthCallback';
import HomePage from './pages/HomePage';
import CreatorDetail from './pages/CreatorDetail';
import AdminPanel from './pages/AdminPanel';
import './App.css';

// Router wrapper to handle auth callback
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - must be synchronous during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Don't show bottom nav on admin page
  const showBottomNav = !location.pathname.startsWith('/admin');
  
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:slug" element={<CreatorDetail />} />
        <Route path="/creator/:creatorId" element={<CreatorDetail />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
      {showBottomNav && <BottomNav />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
